<ul class="sidebar-nav">
  <li class="sidebar-brand">
    <a href="#" translate>SIDEBAR.TITLE</a>
  </li>
  <li>
    <a [routerLink]="[router.url]" (click)="requestFullscreen()" translate>
      <span class="esri-icon-zoom-out-fixed" aria-hidden="true"></span>SIDEBAR.FULLSCREEN</a>
  </li>
  <li>
    <a [routerLink]="[router.url]" (click)="showAppInfoWidget()" translate>
      <span class="esri-icon-notice-round" aria-hidden="true"></span>SIDEBAR.APPINFO</a>
  </li>
  <li *ngIf="creationToolPermitted === true">
    <a [routerLink]="[router.url]" (click)="showCreationWidget()" translate>
      <span class="esri-icon-edit" aria-hidden="true"></span>SIDEBAR.DRAW</a>
  </li>
  <li>
    <a [routerLink]="[router.url]" (click)="showMassStabWidget()" translate>
      <span class="esri-icon-applications" aria-hidden="true"></span>SIDEBAR.MASSSTAB</a>
  </li>
  <!-- Print Widget -->
  <li>
    <a [routerLink]="[router.url]" (click)="showPrintWidget()" translate>
      <span class="esri-icon-printer" aria-hidden="true"></span>SIDEBAR.PRINT</a>
  </li>

  <!-- Measure Widget-->
  <li>
    <a [routerLink]="[router.url]" (click)="showMeasureWidget()" translate>
      <span class="esri-icon-line-chart" aria-hidden="true"></span>SIDEBAR.MEASURE</a>
  </li>

  <!-- Geoportale Widget-->
  <li>
    <a [routerLink]="[router.url]" (click)="showGeoPortaleWidget()" translate>
      <span class="esri-icon-public" aria-hidden="true"></span>SIDEBAR.GEOPORTALE</a>
  </li>

  <!-- GoogleMaps Widget -->
  <li>
    <a [routerLink]="[router.url]" (click)="showGoogleMapsWidget()" translate>
      <img
        class="sidebar-icon"
        alt="Logo"
        src="assets/images/street-view.svg"
      />SIDEBAR.GOOGLE_MAPS</a
    >
  </li>

  <!-- Share Link Widget -->
  <li>
    <a [routerLink]="[router.url]" (click)="showShareWidget()" translate>
      <span class="esri-icon-share" aria-hidden="true"></span>SIDEBAR.SHARE</a>
  </li>

  <!-- WebGis Apps -->
  <li>
    <linkTo-webgis-apps></linkTo-webgis-apps>
  </li>

</ul>
